import axios from 'axios';
import fileDownload from 'js-file-download';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import _ from 'underscore';
import { errorMsg, log } from 'utils';
import { url } from 'utils/url';

export const ANALYTICS_FETCH_DATA_INIT = createAction(
  'ANALYTICS_FETCH_DATA_INIT'
);
export const ANALYTICS_FETCH_DATA_SUCCESS = createAction(
  'ANALYTICS_FETCH_DATA_SUCCESS'
);
export const ANALYTICS_FETCH_OVERVIEW_INIT = createAction(
  'ANALYTICS_FETCH_OVERVIEW_INIT'
);
export const ANALYTICS_FETCH_OVERVIEW_SUCCESS = createAction(
  'ANALYTICS_FETCH_OVERVIEW_SUCCESS'
);
export const ANALYTICS_FETCH_LEADERBOARD_INIT = createAction(
  'ANALYTICS_FETCH_LEADERBOARD_INIT'
);
export const ANALYTICS_FETCH_LEADERBOARD_SUCCESS = createAction(
  'ANALYTICS_FETCH_LEADERBOARD_SUCCESS'
);
export const ANALYTICS_FETCH_PROFILE_SUCCESS = createAction(
  'ANALYTICS_FETCH_PROFILE_SUCCESS'
);
export const ANALYTICS_FETCH_DATA_FAIL = createAction(
  'ANALYTICS_FETCH_DATA_FAIL'
);
export const ANALYTICS_FETCH_LEADERBOARD_FAIL = createAction(
  'ANALYTICS_FETCH_LEADERBOARD_FAIL'
);
export const ANALYTICS_FETCH_OVERVIEW_FAIL = createAction(
  'ANALYTICS_FETCH_OVERVIEW_FAIL'
);
export const ANALYTICS_CALCULATE_DATA_INIT = createAction(
  'ANALYTICS_CALCULATE_DATA_INIT'
);
export const ANALYTICS_CALCULATE_DATA_SUCCESS = createAction(
  'ANALYTICS_CALCULATE_DATA_SUCCESS'
);
export const ANALYTICS_EXPORT_ANALYTIC_INIT = createAction(
  'ANALYTICS_EXPORT_ANALYTIC_INIT'
);
export const ANALYTICS_EXPORT_ANALYTIC_SUCCESS = createAction(
  'ANALYTICS_EXPORT_ANALYTIC_SUCCESS'
);
export const ANALYTICS_EXPORT_ANALYTIC_FAIL = createAction(
  'ANALYTICS_EXPORT_ANALYTIC_FAIL'
);

export const fetchAnalytics = ({
  start,
  end,
  type,
  adsumScreenIds,
  siteId,
}) => {
  return async (dispatch) => {
    dispatch(ANALYTICS_FETCH_DATA_INIT());
    let analytic;
    try {
      analytic = await axios.post(
        `${url}/analytic/get`,

        {
          start,
          end,
          siteId,
          type,
          adsumScreenIds,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(ANALYTICS_FETCH_DATA_FAIL({ error }));
    }

    let dataTable = [];
    log(analytic.data.rawData, 'rawdata');
    const groupedData = await _.groupBy(analytic.data.rawData, 'adsumName');
    const keys = _.keys(groupedData).map((k) =>
      dataTable.push({
        name: k,
        count: groupedData[k].length,
        select: groupedData[k].filter((data) => data.action === 'select')
          .length,
        goto: groupedData[k].filter((data) => data.action === 'goTo').length,
        scan: groupedData[k].filter((data) => data.action === 'scan').length,
      })
    );

    dataTable = _.sortBy(dataTable, 'count');
    log(dataTable, groupedData, keys, analytic.data.rawData, 'analytic result');
    // dispatch(calculateData({ data: analytic.data.rawData }));
    return dispatch(
      ANALYTICS_FETCH_DATA_SUCCESS({
        data: analytic.data.data,
        rawData: analytic.data.rawData,
      })
    );
  };
};
export const fetchLeaderboard = ({ start, end, siteId, adsumScreenIds }) => {
  return async (dispatch) => {
    dispatch(ANALYTICS_FETCH_LEADERBOARD_INIT());
    let analytic;
    try {
      analytic = await axios.post(
        `${url}/analytic/getTop`,

        {
          start,
          end,
          siteId,
          adsumScreenIds,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(ANALYTICS_FETCH_LEADERBOARD_FAIL({ error }));
    }

    // dispatch(calculateData({ data: analytic.data.rawData }));
    return dispatch(
      ANALYTICS_FETCH_LEADERBOARD_SUCCESS({
        data: analytic.data.data,
      })
    );
  };
};
export const fetchOverview = ({ start, end }) => {
  return async (dispatch) => {
    dispatch(ANALYTICS_FETCH_OVERVIEW_INIT());
    let analytic;
    try {
      analytic = await axios.post(
        `${url}/analytic/overview`,

        {
          start,
          end,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(ANALYTICS_FETCH_OVERVIEW_FAIL({ error }));
    }

    // dispatch(calculateData({ data: analytic.data.rawData }));
    return dispatch(
      ANALYTICS_FETCH_OVERVIEW_SUCCESS({
        data: analytic.data.data,
      })
    );
  };
};

export const calculateData = ({ data }) => {
  return async (dispatch) => {
    dispatch(ANALYTICS_CALCULATE_DATA_INIT());

    let result = [];

    const groupedDuration = _.groupBy(data, 'adsumScreenId');
    const keys = Object.keys(groupedDuration);

    result = keys.map((k) => {
      const content = groupedDuration[k];
      return { x: k, y: content.length };
    });

    result = _.sortBy(result, 'y').reverse();

    return dispatch(
      ANALYTICS_CALCULATE_DATA_SUCCESS({
        rawData: result,
      })
    );
  };
};

export const downloadAnalytics = (body) => {
  return async (dispatch) => {
    dispatch(ANALYTICS_EXPORT_ANALYTIC_INIT());
    if (body.type === 'leaderboard') {
      axios
        .post(`${url}/analytic/exportTop`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
          responseType: 'blob',
        })
        .then((res) => {
          fileDownload(
            res.data,
            `logs_export_${body.type}_${moment(new Date()).format(
              'YYYY-MM-DD'
            )}.csv`
          );
          return dispatch(ANALYTICS_EXPORT_ANALYTIC_SUCCESS());
        })
        .catch((error) => {
          toastr.error('', `${errorMsg(dispatch, error)}`);
          return dispatch(ANALYTICS_EXPORT_ANALYTIC_FAIL({ error }));
        });
    } else {
      axios
        .post(`${url}/analytic/exportAll`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
          responseType: 'blob',
        })
        .then((res) => {
          fileDownload(
            res.data,
            `logs_export_rawdata_${moment(new Date()).format('YYYY-MM-DD')}.csv`
          );
          return dispatch(ANALYTICS_EXPORT_ANALYTIC_SUCCESS());
        })
        .catch((error) => {
          toastr.error('', `${errorMsg(dispatch, error)}`);
          return dispatch(ANALYTICS_EXPORT_ANALYTIC_FAIL({ error }));
        });
    }
  };
};
export const downloadAnalyticsLeaderboard = (body) => {
  return async (dispatch) => {
    dispatch(ANALYTICS_EXPORT_ANALYTIC_INIT());

    axios
      .post(`${url}/analytic/export`, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
        responseType: 'blob',
      })
      .then((res) => {
        fileDownload(
          res.data,
          `logs_export_${body.type}_${moment(new Date()).format(
            'YYYY-MM-DD'
          )}.csv`
        );
        return dispatch(ANALYTICS_EXPORT_ANALYTIC_SUCCESS());
      })
      .catch((error) => {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(ANALYTICS_EXPORT_ANALYTIC_FAIL({ error }));
      });
  };
};

export const loadingAnalytic = () => {
  return async (dispatch) => {
    return dispatch(ANALYTICS_FETCH_DATA_INIT());
  };
};
